import React from 'react';
import ContactInfoToggle from "../Contacts/ContactInfoToggle";
import ContactInfo from "../Contacts/ContactInfo";


const TimelineHeader = (props) => {


  return (
    <div>
      <div className="eXa-container">
        <div className="eXa-col m9">
          <h1>{props.contactId}</h1>
        </div>
        <div className="eXa-col m3">
          <ContactInfoToggle 
            showContactInfo={props.showContactInfo}
            clicked={props.clicked}
          />
        </div>
      </div>
      <ContactInfo
        contactCards={props.contactCards}
        showContactInfo={props.showContactInfo}
        didMount={props.didMount}
      />
    </div>
  );
}

export default TimelineHeader;


// WEBPACK FOOTER //
// ./src/containers/Timeline/TimelineHeader.js